require('./warrantiesList.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const WarrantiesTableRow = require('components/contactCenter/creditWarranties/warrantiesList/warrantiesTableRow/warrantiesTableRow');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @actions
const creditWarrantiesActions = require('actions/contactCenter/creditWarranties');

class WarrantiesList extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
      const {immCredit, requestCreditWarranties} = this.props;
      const creditId = immCredit.get('id');
      requestCreditWarranties(creditId);
    }

    buildContent() {
        const { immCredit, immWarranties } = this.props;
        const creditId = immCredit.get('id');

        if (immWarranties.get('isFetching')) {
            return <LoadingSection />
        }

        if (immWarranties.get('error')) {
            return this.buildEmptyState(creditId, 'creditWarranties-emptyStateErrorMessage');
        }

        if (!immWarranties.get('byOrder').count()) {
            return this.buildEmptyState(creditId, 'creditWarranties-noResults');
        }

        return this.buildTable();

    }

    buildEmptyState(creditId, messageKey) {
        const linkText = formatText('creditWarranties-mainButton').toUpperCase();
        const linkUrl = `/myprofile/loans-mortgages/credit/investment-credit/${creditId}`;

        return (
            <EmptyState
                primaryText={formatText(messageKey)}
                linkText={linkText}
                linkURL={linkUrl}
            />
        );
    }

    buildTable() {
        const { immWarranties } = this.props;
        const immWarrantiesById = immWarranties.get('byId');
        const immWarrantiesByOrder = immWarranties.get('byOrder');

        return (
            <OKSectionBox>
                <LastMovementsTable
                    rowComponent={WarrantiesTableRow}
                    immTransactionsById={immWarrantiesById}
                    immTransactionsByOrder={immWarrantiesByOrder}
                    columnsCount={3}
                    id="credit-warranties-table"
                    groupByDate={false}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="warranties-list__table-cell-header"
                            >
                                <FormattedText value="creditWarranties-number" />
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="warranties-list__table-cell-header"
                            >
                                <FormattedText value="creditWarranties-description" />
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="warranties-list__table-cell-header"
                            >
                                <FormattedText value="creditWarranties-assessment" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
            </OKSectionBox>
        );
    }

    render() {
        const headerTitle = formatText('creditWarranties-listTitle');
        const content = this.buildContent();

        return (
            <section>
                <header className="warranties-list__title">
                    <OKBoxTitle value={headerTitle} inline={true} />
                </header>
                {content}
            </section>
        );
    }

}

WarrantiesList.propTypes = {
    immCredit: PropTypes.object.isRequired,
    immWarranties: PropTypes.object,
    requestCreditWarranties: PropTypes.func.isRequired
};

module.exports = WarrantiesList;
module.exports.WarrantiesList = connect(
    state => ({
        immWarranties: state.creditWarranties
    }),
    {
        requestCreditWarranties: creditWarrantiesActions.requestWarranties
    }
)(WarrantiesList);
